import * as BABYLON from '@babylonjs/core';
import { BasePlayer } from './BasePlayer';
import { GlobalObject } from './../../utils/GlobalObject';
import { Vector } from './../../utils/Vector';

export class Player extends BasePlayer {
  public player?: BABYLON.AbstractMesh;

  private keys = {
    jump: 0,
    fly: 0,
    left: 0,
    right: 0,
    forward: 0,
    back: 0
  }
  private action: number = 0;
  public speedNum: number = (GlobalObject.getInstance().main.camSpeed || 0.3) * 0.33;
  private speed: number = 0;
  private state: string = 'idle';

  public sitData: any;
  public locked: boolean = false;

  constructor(scene: BABYLON.Scene, camera: BABYLON.ArcRotateCamera) {
    super(scene, camera);
    this.addPlayer();
  }
  private async addPlayer() {
    if (this.player) {
      return;
    }
    const dirBox = BABYLON.MeshBuilder.CreateBox("box", { size: 8, width: 0.45, height: 1.8, depth: 0.45 }, this.scene);
    const mat2 = new BABYLON.StandardMaterial("mat2", this.scene);
    mat2.diffuseColor = new BABYLON.Color3(0, 0.3, 0.8);
    mat2.alpha = 0.3;
    dirBox.material = mat2;
    dirBox.name = "dirBox";
    dirBox.isPickable = false;
    const targetBox = BABYLON.MeshBuilder.CreateBox("targetBox", { size: 1, width: 0.2, height: 0.2, depth: 0.2 }, this.scene);
    targetBox.material = mat2;
    targetBox.name = "targetBox";
    targetBox.position.y = 0.7;
    targetBox.isPickable = false;
    dirBox.checkCollisions = true;

    targetBox.setParent(dirBox);
    this.player = dirBox;
    targetBox.visibility = 0;
    dirBox.visibility = 0;
    this.camera.setTarget(targetBox);
    this.camera.alpha = -16.6;
    this.camera.beta = 1.22; // 俯视角度，角度越小看的目标越接近脚下

    this.player.position.x = -370;
    this.player.position.y = 120;
    this.player.position.z = 350;

    // 键盘控制人物前后左右行走
    this.initKey();
    // 更新
    this.scene.registerBeforeRender(() => {
      this.update();
    });
  }
  private initKey() {
    window.addEventListener('keydown', this.handleKeyDown.bind(this), false);
    window.addEventListener('keyup', this.handleKeyUp.bind(this), false);
  }
  public handleKeyDown(evt: any) {
    if (this.locked) {
      return;
    }
    if (evt.keyCode == 65 || evt.key == 'ArrowLeft') this.keys.left = 1; this.walk(); // A
    if (evt.keyCode == 68 || evt.key == 'ArrowRight') this.keys.right = 1; this.walk(); // D
    if (evt.keyCode == 87 || evt.key == 'ArrowUp') this.keys.forward = 1; this.walk(); // W
    if (evt.keyCode == 83 || evt.key == 'ArrowDown') this.keys.back = 1; this.walk(); // S
    if (evt.keyCode == 70) this.sitdown(); // P	80 F 70
    if (evt.keyCode == 16) this.speedNum = GlobalObject.getInstance().main.camSpeed || 0.3; // shift

    if (this.action !== evt.keyCode) {
      this.action = evt.keyCode
    }
  }
  public handleKeyUp(evt: any) {
    if (evt.keyCode == 65 || evt.key == 'ArrowLeft') this.keys.left = 0; this.idle();
    if (evt.keyCode == 68 || evt.key == 'ArrowRight') this.keys.right = 0; this.idle();
    if (evt.keyCode == 87 || evt.key == 'ArrowUp') this.keys.forward = 0; this.idle();
    if (evt.keyCode == 83 || evt.key == 'ArrowDown') this.keys.back = 0; this.idle();
    if (evt.keyCode == 16) this.speedNum = (GlobalObject.getInstance().main.camSpeed || 0.3) * 0.33;

    this.action = evt.keyCode
  }
  public walk() {
    this.speed = this.speedNum;
  }
  public idle() { }
  public sitdown() { }

  public update() {
    if (!this.player || !this.player.position) {
      return;
    }
    this.camera = this.camera as BABYLON.ArcRotateCamera;
    const cameraForwardRayPosition = this.camera.getForwardRay().direction
    const cameraForwardRayPositionWithoutY = new BABYLON.Vector3(cameraForwardRayPosition.x, 0, cameraForwardRayPosition.z)
    if (this.player.physicsImpostor) {
      this.player.physicsImpostor?.setLinearVelocity(new BABYLON.Vector3(0, 0, 0));
      this.player.physicsImpostor?.setAngularVelocity(new BABYLON.Vector3(0, 0, 0));
    }
    // 键盘操作
    let forwardVec = new BABYLON.Vector3(cameraForwardRayPosition.x * this.speed, 0, cameraForwardRayPosition.z * this.speed);
    if (this.keys) {
      if (this.keys.left) {
        this.player.moveWithCollisions(this.rotateY(forwardVec, 90));
      }
      if (this.keys.right) {
        this.player.moveWithCollisions(this.rotateY(forwardVec, 270));
      }
      if (this.keys.forward) {
        this.player.lookAt(this.player.position.add(cameraForwardRayPositionWithoutY), 0, 0, 0)
        this.player.moveWithCollisions(forwardVec);
      }
      if (this.keys.back) {
        this.player.lookAt(this.player.position.add(cameraForwardRayPositionWithoutY), 0, 0, 0)
        this.player.moveWithCollisions(new BABYLON.Vector3(forwardVec.x * -1, forwardVec.y, forwardVec.z * -1));
      }
    }
  }
  private rotateY(v: BABYLON.Vector3, degree: number) {
    const angle = degree * Math.PI / 180;
    const x = v.x * Math.cos(angle) - v.z * Math.sin(angle);
    const z = v.x * Math.sin(angle) + v.z * Math.cos(angle);
    return new BABYLON.Vector3(x, v.y, z);
  }
}